import { Component, OnInit } from '@angular/core';
import * as RecordRTC from 'recordrtc';
import { DomSanitizer } from '@angular/platform-browser';
import * as WaveSurfer from 'wavesurfer.js';
import * as MicrophonePlugin from 'wavesurfer.js/dist/plugin/wavesurfer.microphone.js';
WaveSurfer.microphone = MicrophonePlugin;
@Component({
  selector: 'app-record1',
  templateUrl: './record1.component.html',
  styleUrls: ['./record1.component.sass']
})
export class Record1Component implements OnInit {
  audioUrl;
  wsurfer;
  context; processor;
  interval; recordingTimer: string; recordWebRTC: any; mediaRecordStream: any;
  options: any = {
    type: 'audio',
    mimeType: 'audio/webm'
  }

  constructor(  private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
  }

  start() {
   
    navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
     // this.startRTC(stream);
     this.recordWebRTC = new RecordRTC.StereoAudioRecorder(stream, this.options);
     this.mediaRecordStream = stream;
     this.audioUrl = null;
     this.recordWebRTC.record();
     this.startCountdown();
     let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
     if (isSafari) {
       //= new (window['AudioContext'] || window['webkitAudioContext'])();
      let AudioContext =window.AudioContext || window['webkitAudioContext'];
      this.context = new AudioContext();
      this.processor = this.context.createScriptProcessor(1024, 1, 1);
  }
     this.wsurfer = WaveSurfer.create({
      container: '#waveform',
      waveColor: '#57afa2',
      progressColor: '#57afa2',
      audioContext: this.context || null,
      audioScriptProcessor: this.processor || null,
      barHeight: 2,
      plugins: [
         MicrophonePlugin.create()
      ]
    });
    this.wsurfer.setMute(true);
    this.wsurfer.microphone.start();
     /* this.wsurfer = WaveSurfer.create({
      container: '#waveform',
      waveColor: '#57afa2',
      progressColor: '#57afa2',
      barHeight: 2,
      plugins: [
        MicrophonePlugin.create({
          bufferSize: 4096,
          numberOfInputChannels: 1,
          numberOfOutputChannels: 1,
          constraints: {
            video: false,
            audio: true
          }
        })
      ]
    });
    this.wsurfer.microphone.start();  */
    }).catch(error => {
      alert(error)
    })


  }
  startCountdown(clearTime = false) {
    let THIS=this;
    if (clearTime) {
      this.clearStream(this.mediaRecordStream);
      this.recordWebRTC = null;
      this.recordingTimer = null;
      this.mediaRecordStream = null;
      clearInterval(this.interval);
      return
    } else {
      this.recordingTimer = `0`;
      clearInterval(this.interval);
    }

    this.interval = setInterval(() => {
      let timer: any = this.recordingTimer;
      let seconds = +timer;

      if (seconds == 5) {
       this.stopRTC();
        this.wsurfer.microphone.stop();
        clearInterval(this.interval);
        return
      }
      ++seconds;
        this.recordingTimer = `${seconds}`;
    }, 1000);
  }
  clearStream(stream: any) {
    try {
      stream.getAudioTracks().forEach(track => track.stop());
      stream.getVideoTracks().forEach(track => track.stop());
    } catch (error) {
      //stream error
    }
  }
  stopRTC() {
    this.recordWebRTC.stop((blob) => {
      this.audioUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
      this.startCountdown(true);
    })
  }
}
